/* eslint-disable max-len */
/**
 * @description Create css styles for Brand Color Feature
 * @param designSettings
 * @return {string}
 * @private
 */
export default function (designSettings = {}) {
    const generalDesignSettings = designSettings.general || {};
    const color = generalDesignSettings.brandColor;
    if (!color) return '';

    const generalBrandStyles = {
        '.custom-togglebtn__icon:before': { backgroundColor: color },
        '.custom-togglebtn--invert .custom-togglebtn__icon': { backgroundColor: color },
    };

    const iconStyles = {
        '.app-icon--build-exlamation-mark-brand .app-icon__svg': { fill: color },
        '.app-icon--popup-interval-selected .app-icon__svg': { fill: color },
        '.app-icon--popup-lock-selected .app-icon__svg': { fill: color },
        '.app-icon--popup-lshare-selected .app-icon__svg': { fill: color },
        '.app-icon--popup-public-selected .app-icon__svg': { fill: color },
        '.app-icon--popup-week-selected .app-icon__svg': { fill: color },
        '.app-icon--popup-disable-selected .app-icon__svg': { fill: color },
        '.app-icon--general-bulb-filled .app-icon__svg': { fill: color },
        '.app-icon--general-bulb-shift .app-icon__svg': { fill: color },
        '.app-icon--general-export-out .app-icon__svg': { fill: color },
        '.app-icon--general-flag-yellow .app-icon__svg': { fill: color },
        '.app-icon--general-relationship-tool-tip .app-icon__svg': { fill: color },
        '.app-icon--general-yellow-round-add .app-icon__svg': { fill: color },
        '.app-icon--hint-question-mark .app-icon__svg': { fill: color },
        '.app-icon--hint-x .app-icon__svg': { fill: color },
        '.app-icon--schema-arrow-close-left .app-icon__svg': { fill: color },
        '.app-icon--schema-arrow-close-right .app-icon__svg': { fill: color },
        '.app-icon--placeholder-database .app-icon__svg': { fill: color },
        '.app-icon--placeholder-database-x .app-icon__svg': { fill: color },
        '.app-icon--placeholder-connection .app-icon__svg': { fill: color },
        '.app-icon--placeholder-filter .app-icon__svg': { fill: color },
        '.app-icon--placeholder-git-graph .app-icon__svg': { fill: color },
        '.app-icon--placeholder-search-x .app-icon__svg': { fill: color },
        '.app-icon--placeholder-search .app-icon__svg': { fill: color },
        '.app-icon--placeholder-table .app-icon__svg': { fill: color },
        '.app-icon--placeholder-table-x .app-icon__svg': { fill: color },
        '.app-icon--placeholder-table-init .app-icon__svg': { fill: color },
        '.app-icon--placeholder-sheet .app-icon__svg': { fill: color },
        '.app-icon--placeholder-mark-exclamation .app-icon__svg': { fill: color },
        '.app-icon--placeholder-mark-vi .app-icon__svg': { fill: color },
        '.app-icon--placeholder-tools .app-icon__svg': { fill: color },
        '.app-icon--placeholder-preview .app-icon__svg': { fill: color },
        '.app-icon--placeholder-place-file .app-icon__svg': { fill: color },
        '.app-icon--placeholder-place-text-add .app-icon__svg': { fill: color },
        '.app-icon--illustration-build-succeeded .app-icon__svg': { fill: color },
        '.app-icon--illustration-build-failed .app-icon__svg': { fill: color },
        '.app-icon--homepages-video .app-icon__svg': { fill: color },
        '.app-icon--homepages-tutorials .app-icon__svg': { fill: color },
        '.app-icon--homepages-documentation .app-icon__svg': { fill: color },
        '.app-icon--homepages-sample .app-icon__svg': { fill: color },
        '.app-icon--buildpanel-replace-all .app-icon__svg': { fill: color },
        '.app-icon--buildpanel-by-table .app-icon__svg': { fill: color },
        '.app-icon--buildpanel-changes-only .app-icon__svg': { fill: color },
        '.app-icon--header-user-filled .app-icon__svg': { fill: color },
    };

    return {
        ...generalBrandStyles,
        ...iconStyles,
    };
}
